import HttpClient from './HttpClient';

const NotificacionesService = {
  getNotificacion: () => {
    const path = 'notificacion';
    return HttpClient.get(path, {}, true);
  },
  getCatalogoNotificacion: (params) => {
    const path = 'notificacion/catalogo';
    return HttpClient.get(path, params, true);
  },
  saveNotificaciones: (params) => {
    const path = 'notificacion';
    return HttpClient.post(path, params, true);
  },
  crearNotificaciones: (params) => {
    const path = 'notificacion/nueva';
    return HttpClient.post(path, params, true);
  },
  lectura: (id) => {
    const path = `notificacion/lectura/${id}`;
    return HttpClient.get(path, {}, true, true);
  }
};

export default NotificacionesService;
